import axios from "axios";
import { createContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
// import Cookies from "js-cookie";
import Toast from "../../components/Sweetalert/Sweetalert";
import { API } from "../../shared/api/Api";
import {
  clearAuthData,
  selectUserInformations,
} from "../../features/authSlice";
import { useDispatch, useSelector } from "react-redux";
import { useStreamVideoClient } from "@stream-io/video-react-sdk";
import { clearAuthCookies } from "../../utils/cookieUtils";
export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [isCollapsed, setIsCollapsed] = useState(true);
  const nav = useNavigate();
  const user = useSelector(selectUserInformations);
  const [trueEdit, setTrueEdit] = useState(false);
  const [loader, setLoader] = useState(false);
  const dispatch = useDispatch();

  // In your AuthContext provider
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth >= 1024) {
        setMenuOpen(false);
      }
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleLogout = (e) => {
    e.preventDefault();
    axios
      .post(
        API.Admin.logout,
        {},
        {
          headers: {
            Authorization: `Bearer ${user?.token}`,
            Accept: "application/json",
          },
        }
      )
      .then((res) => {
        if (res.data.status === 200) {
          dispatch(clearAuthData());
          try {
            clearAuthCookies();
          } catch (cookieError) {
            console.error("Failed to clear cookies:", cookieError);
          }
          Toast.fire({
            icon: "success",
            text: `${res.data.message}`,
          });
          nav("/Login");
        }
      })
      .catch((err) => {
        console.log(err);
        if (err?.response?.data?.message === "Unauthenticated.") {
          Toast.fire({
            text: err.response?.data?.message,
            icon: "warning",
          });
          nav("/Login");
        }
      });
  };
  return (
    <AuthContext.Provider
      value={{
        menuOpen,
        setMenuOpen,
        handleLogout,
        trueEdit,
        setTrueEdit,
        loader,
        setLoader,
        isCollapsed,
        setIsCollapsed,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};
